import { Capacitor } from '@capacitor/core';

import { FB_PIXEL_ID } from '../env';

/**
 * Facebook Pixel — cookies-only mode.
 *
 * We load the Pixel SDK solely so it sets the first-party `_fbp` and `_fbc`
 * cookies, which we then forward to Facebook's Conversions API server-side
 * via `recordEvent` in user.service.ts. We deliberately do NOT call
 * `fbq('track', 'PageView')` or any other track call, so Facebook never
 * receives a client-side event from us. All conversion events flow through
 * CAPI only — no client/server duplication is possible because there is
 * no client-side stream to dedupe against.
 *
 * On Capacitor native (iOS/Android), Pixel cookies don't behave reliably
 * across the WebView/native bridge, so we skip loading entirely and let
 * the manual `fbp`/`fbc` generation in segment.ts handle attribution.
 *
 * The bootstrap snippet below is Facebook's official installation code
 * from https://developers.facebook.com/docs/meta-pixel/get-started.
 */
if (FB_PIXEL_ID && !Capacitor.isNativePlatform()) {
  /* eslint-disable */
  // @ts-expect-error - fbq is injected onto window by the snippet below
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */

  // Init only — this sets `_fbp` and (when fbclid is in the URL) `_fbc`.
  // We intentionally omit `fbq('track', 'PageView')`.
  window.fbq('init', FB_PIXEL_ID);
}
